<template>
<span>
  <v-select v-model="model" :items="values" :label="label" :menu-props="{ maxHeight: '400' }" item-text="value"
            item-value="key"
            multiple></v-select>
  {{ description }}
</span>
</template>

<script>
import {
  input
} from '@/mixins/input'

export default {
  mixins: [input],
  computed: {
    values() {
      return this.field.values
    }
  },
  created() {
  },
}
</script>

<style>
</style>
